var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPrint = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 1.66675C14.6263 1.66675 14.9993 2.03985 14.9993 2.50008V5.83341H17.4993C17.9596 5.83341 18.3327 6.20651 18.3327 6.66675V15.0001C18.3327 15.4603 17.9596 15.8334 17.4993 15.8334H14.9993V17.5001C14.9993 17.9603 14.6263 18.3334 14.166 18.3334H5.83268C5.37245 18.3334 4.99935 17.9603 4.99935 17.5001V15.8334H2.49935C2.03912 15.8334 1.66602 15.4603 1.66602 15.0001V6.66675C1.66602 6.20651 2.03912 5.83341 2.49935 5.83341H4.99935V2.50008C4.99935 2.03985 5.37245 1.66675 5.83268 1.66675H14.166ZM13.3327 14.1667H6.66602V16.6667H13.3327V14.1667ZM16.666 7.50008H3.33268V14.1667H4.99935V13.3334C4.99935 12.8732 5.37245 12.5001 5.83268 12.5001H14.166C14.6263 12.5001 14.9993 12.8732 14.9993 13.3334V14.1667H16.666V7.50008ZM6.66602 8.33341V10.0001H4.16602V8.33341H6.66602ZM13.3327 3.33341H6.66602V5.83341H13.3327V3.33341Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrint, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Print.dd7230e9.svg";
export { ForwardRef as ReactComponent };